import { insertSplash } from '@ms/yammer-web-support/dist/splash';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const config = require(`./${process.env.YAMMER_ENV}.json`);

insertSplash({ target: document.getElementById('root') });

window.__yammerconfig__ = config;
